import { useTX } from '@transifex/react';
import { ChevronLeft } from 'lucide-react';
import { useLocation, useSubmit } from 'react-router';
import {
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from '~/components/ui/dropdown-menu';
import { ampli } from '~/third-party/ampli/.client';
import { LANGUAGES } from '~/lib/languages';

type NavbarLanguageMenuProps = {
  onBack: () => void;
};

export function NavbarLanguageMenu({ onBack }: NavbarLanguageMenuProps) {
  const tx = useTX();
  const locale = tx.getCurrentLocale();
  const location = useLocation();
  const submit = useSubmit();

  function handleLangChange(lang: string) {
    ampli.selectLanguage({ language: lang });
    submit(
      { lang, next: location.pathname + location.search },
      { method: 'post', action: '/lang', replace: true }
    );
  }

  return (
    <>
      <DropdownMenuItem
        onSelect={e => {
          e.preventDefault();
          onBack();
        }}
        aria-label="Back to menu"
      >
        <ChevronLeft className="size-4 text-text-900" />
      </DropdownMenuItem>
      <DropdownMenuRadioGroup value={locale} onValueChange={handleLangChange}>
        {LANGUAGES.map(lang => (
          <DropdownMenuRadioItem
            key={lang.code}
            value={lang.code}
            className="text-body-big text-text-900"
          >
            {lang.label}
          </DropdownMenuRadioItem>
        ))}
      </DropdownMenuRadioGroup>
    </>
  );
}
